var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"result":_vm.result,"loadingResult":_vm.loading,"updateResult":_vm.update,"changeResult":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }